import { useState } from "react";
import { Menu, X } from "lucide-react";
import { BrandBadge } from "@/components/BrandMark";

const LINKS = [
  { id: "features", text: "Features" },
  { id: "pricing", text: "Pricing" },
  { id: "about", text: "About" },
];

/* Slim public nav. Cold traffic from paid social needs to see that pricing exists before it
   decides to scroll, so these are jump links on the same page — nothing extra to load. */
export const SplashNav = ({ onLogin }) => {
  const [open, setOpen] = useState(false);

  const jump = (id) => {
    setOpen(false);
    // Scroll on the next frame: measuring the target while the ~190px menu is still in the sticky
    // nav's flow height left every section about 190px too high once the menu collapsed.
    requestAnimationFrame(() =>
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" }));
  };

  return (
    <nav
      data-testid="splash-nav"
      className="sticky top-0 z-40 border-b border-white/10 bg-royal-deep/95 backdrop-blur-md"
      style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
    >
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-3 sm:px-6">
        <button
          type="button"
          data-testid="splash-nav-home"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 min-h-[44px]"
        >
          <BrandBadge size="h-8 w-8" icon="h-5 w-5" />
          <span className="font-display text-base font-semibold text-white">Cornerstone Ops</span>
        </button>

        <div className="ml-auto hidden items-center gap-7 sm:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              type="button"
              data-testid={`splash-nav-${l.id}`}
              onClick={() => jump(l.id)}
              className="text-sm font-semibold text-blue-100/80 transition-colors duration-200 hover:text-gold"
            >
              {l.text}
            </button>
          ))}
          <button
            type="button"
            data-testid="splash-nav-login"
            onClick={onLogin}
            className="rounded-full border border-white/25 px-4 py-1.5 text-sm font-semibold text-white transition-colors duration-200 hover:border-gold hover:text-gold"
          >
            Log in
          </button>
        </div>

        <button
          type="button"
          data-testid="splash-nav-toggle"
          aria-label="Open menu"
          onClick={() => setOpen((v) => !v)}
          className="ml-auto flex h-11 w-11 items-center justify-center rounded-lg text-white sm:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 px-4 pb-3 sm:hidden" data-testid="splash-nav-menu">
          {LINKS.map((l) => (
            <button
              key={l.id}
              type="button"
              data-testid={`splash-nav-m-${l.id}`}
              onClick={() => jump(l.id)}
              className="block min-h-[44px] w-full text-left text-sm font-semibold text-blue-100/85"
            >
              {l.text}
            </button>
          ))}
          <button
            type="button"
            data-testid="splash-nav-m-login"
            onClick={() => { setOpen(false); onLogin(); }}
            className="block min-h-[44px] w-full text-left text-sm font-semibold text-gold"
          >
            Log in
          </button>
        </div>
      )}
    </nav>
  );
};
